/* eslint-disable jira/filename-case */
// This id must match the TEST_ID in src/packages/platform/page-container-v2/src/common/ui/sidebar/index.tsx
export const SIDEBAR_TEST_ID = 'page-layout.sidebar' as const;

export const PACKAGE_NAME = 'jira-nav-platform-integration-sidebar';
export const TEAM_NAME = 'navx';
